module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zone Name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "step": "1"
    },
    model: {
      value: (_vm.form.lowLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lowLimit", $$v)
      },
      expression: "form.lowLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Panel ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.highLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "highLimit", $$v)
      },
      expression: "form.highLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addZone
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5adbbd04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddZone.vue
// module id = 1402
// module chunks = 1